import { render, staticRenderFns } from "./gig-extension.page.vue?vue&type=template&id=58e5bafc&scoped=true&"
import script from "./gig-extension.page.vue?vue&type=script&lang=js&"
export * from "./gig-extension.page.vue?vue&type=script&lang=js&"
import style0 from "./gig-extension.page.vue?vue&type=style&index=0&id=58e5bafc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e5bafc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
